import { render, staticRenderFns } from "./SelectUnitSparepart.vue?vue&type=template&id=72af2018&"
import script from "./SelectUnitSparepart.vue?vue&type=script&lang=ts&"
export * from "./SelectUnitSparepart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72af2018')) {
      api.createRecord('72af2018', component.options)
    } else {
      api.reload('72af2018', component.options)
    }
    module.hot.accept("./SelectUnitSparepart.vue?vue&type=template&id=72af2018&", function () {
      api.rerender('72af2018', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/WorkOrder/SelectUnitSparepart.vue"
export default component.exports